<template>
    <section id="imageEditor" class="flexContainer fd-c full" v-if="Object.keys(product).length > 0">
        <h1 class="uppercase txtCenter listTitle" v-if="product.infosArticle.hasOwnProperty('diam_ref1')">
            {{ $tradFor(product.terms.name) }} [ {{ product.id }} ] <br />
            Ref diam : {{ product.infosArticle.diam_ref1.componentProperty.value }}
        </h1>
        <h1 class="uppercase txtCenter listTitle" v-else="">{{ $tradFor(product.terms.name) }} [ {{ product.id }} ] <br /></h1>
        <div id="app">
            <div class="container">
                <ul class="collection with-header">
                    <draggable :list="getImgObject" class="dragArea" @end="endDrag()">
                        <div
                            v-for="(img, key) in getImgObject"
                            :key="key"
                            class="collection-item center box borderImg"
                            @mouseover="activeImg(img.id)"
                            @mouseleave="inactiveImg()"
                            :style="{
                                border: (actImg === img.id ? '3' : '1') + 'px solid' + (actImg === img.id ? linkColor : '#9b9b9b'),
                                backgroundColor: actImg === img.id ? linkColor + '40' : 'transparent'
                            }"
                        >
                            <div class="encart" :style="'background:' + (actImg === img.id ? linkColor : '#9b9b9b')">
                                <span class="number">{{ key + 1 }}</span>
                            </div>
                            <img v-if="img.img.hasOwnProperty('medium')" :src="getImgPath(img.img.medium)" alt="" height="100" class="imageEditor" />
                            <img v-else="" :src="img.img.filename" alt="" height="100" class="imageEditor" />
                            <div v-if="!!img.img.name" class="imageTypeInfo">{{ img.img.name[$t("trad")] }}</div>
                            <div :id="'deletedImg' + key" class="deleteImg pointer" @click="removeImageFromProduct(img.id)">
                                {{ $t("imgEditor.delete") }}
                            </div>
                        </div>
                    </draggable>
                </ul>
            </div>
        </div>
        <br />
        <div class="center">{{ $t("imgEditor.infoDrag") }}</div>
        <br />
        <div class="center upload">
            <div class="thumbnail">
                <div class="ai-fe" :key="index" v-for="(n, index) in range">
                    <div class="labelInfo">
                        <label class="bold">{{ $t("imgEditor.labelImg") }}</label>
                        <vue-base64-file-upload
                            class="upload flexContainer ai-fe labelInfo container-upload"
                            :id="'photo' + index"
                            accept="image/png,image/jpeg,image/svg+xml"
                            image-class="thumbnail"
                            input-class="thumbnail"
                            :max-size="customImageMaxSize"
                            @size-exceeded="onSizeExceeded"
                            @file="onFile"
                            @load="onLoad"
                            style="width: 200px"
                            enctype="multipart/form-data"
                        />
                        <div v-if="uploadError" class="uploadError">{{ uploadError }}</div>
                    </div>
                    <br />
                    <div class="labelInfo">
                        <label class="bold" v-if="product.type.name !== 'product'">{{ $t("imgEditor.labelSelect") }}</label>
                        <div v-if="product.type.name !== 'product'" class="upload labelInfo">
                            <select :name="'typePhoto' + index" :id="'typePphoto' + index" v-model="selectedType[index]" @change="fileType(index)">
                                <option :value="type.id" :key="index" v-for="(type, index) in userFT">{{ type.name[$t("trad")] }}</option>
                            </select>
                            <span v-if="erreur" style="color: red">Veuillez sélectionner un type</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="center">
            <div class="fd-r mt10">
                <!-- <button class="btn uppercase save" @click="cancel()">{{ $t("common.cancel") }}</button> -->
                <button @click="editPhoto()" class="save btn pointer uppercase">{{ $t("imgEditor.save") }}</button>
            </div>
            <br />
            <br />
            <br />
        </div>
        <div class="center">
            <button class="btn uppercase" @click="cancel()">{{ "back to catalogue item" }}</button>
        </div>
        <div id="spinnerLoader" class="abs flexContainer" v-if="loading === true">
            <Spinner :animation-duration="2500" :size="70" :color="'#41b4e8'" class="loader"></Spinner>
        </div>
    </section>
</template>

<style lang="scss" scoped>
@import "../../assets/css/themes";
.borderImg {
    border: solid #9b9b9b 1px;
}
.labelInfo {
    display: inline-block;
}

.container-upload {
    img {
        display: block;
        max-height: 100px;
        max-width: 100px;
    }
}

.imageEditor {
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 12px;
}
.box {
    margin-top: 50px;
    display: block;
    width: 130px;
    height: 200px;
    position: relative;
    overflow: hidden;
    margin-left: 20px;
    padding: 12px;
}
.encart {
    width: 80px;
    height: 80px;
    position: absolute;
    top: -40px;
    right: -40px;
    transform: rotate(45deg);
    color: #fff;
    font-family: helvetica;
}
.number {
    position: absolute;
    transform: rotate(-45deg);
    bottom: 5px;
    right: 35%;
    font-size: 25px;
    color: #fff;
}
.collection-item {
    height: 180px;
    display: inline-block;
    list-style: none;
}
.save {
    margin-left: 10px;
}

.upload {
    margin-top: 10px;
}

#spinnerLoader {
    background-color: rgba(0, 0, 0, 0.5);
    height: auto;
    width: 100%;
    height: calc(100vh - 155px);
    left: 0;
    .loader {
        margin: auto;
    }
}

.deleteImg {
    padding-top: 12px;
    font-family: Roboto;
    font-size: 14px;
    text-align: center;
}

.imageTypeInfo {
    font-size: 10px;
    text-align: center;
}

#imageEditor {
    @extend %primary-text;
    article {
        .imagesWrapper {
            padding-left: 600px;
            .imageBox {
                padding-left: 15px;
                img {
                    object-fit: contain;
                    height: 200px;
                    width: 200px;
                }
            }
        }
    }
    .mt10 {
        margin-top: 10px;
    }
    .cross {
        display: none;
    }
}

.hidden {
    display: none;
}
.uploadError {
    color: red;
    max-width: 200px;
}
</style>
<script>
import Globals from "../globals.js"; // eslint-disable-line no-unused-vars
import { mapActions, mapGetters } from "vuex"; // eslint-disable-line no-unused-vars
import VueBase64FileUpload from "vue-base64-file-upload"; // eslint-disable-line no-unused-vars
import httpService from "../service";
import Vue from "vue";
import Spinner from "vue-simple-spinner";
import Toast from "vue-easy-toast";
import draggable from "vuedraggable";
import cacheService from "@/services/cache";

Vue.use(Toast);

// Doit rester aligne avec App\Service\ImageConverter::getExtension (back) :
// tout autre format provoque une erreur 400 a l'enregistrement.
const ALLOWED_IMAGE_DATA_URI = /^data:image\/(png|jpe?g|svg\+xml|svg);base64,/i;

export default {
    components: {
        VueBase64FileUpload,
        Spinner,
        draggable
    },
    data: () => ({
        loading: false,
        customImageMaxSize: 4,
        range: [0],
        selectedType: [],
        product: {},
        userString: "",
        order: [],
        userFT: [],
        updatedInfos: {
            files: []
        },
        imgType: null,
        type: null,
        uri: undefined,
        uploadError: null,
        formatRejected: false,
        imgComponent: [],
        linkColor: cacheService.getLinkColor(),
        actImg: null,
        img: false,
        erreur: false
    }),
    watch: {},
    methods: {
        endDrag() {
            let imgObjectSave = [];
            for (let i in this.imgComponent) {
                this.imgComponent[i].img.order = parseInt(i, 10) + 1;
                this.imgComponent[i].img.id = this.imgComponent[i].id;
            }
        },
        ...mapActions({
            setImgObject: "items/setImgObject"
        }),
        activeImg(id) {
            this.actImg = id;
            this.img = true;
        },
        inactiveImg() {
            this.actImg = null;
            this.img = false;
        },
        cancel() {
            location.replace("/" + this.product.type.name + "/" + this.$route.params.id);
        },
        removeImageFromProduct(imgId) {
            let tmp = [];
            for (let i in this.imgComponent) {
                this.imgComponent[i].img.order = parseInt(i, 10) + 1;
                this.imgComponent[i].img.id = this.imgComponent[i].id;
                if (this.imgComponent[i].img.hasOwnProperty("medium")) {
                    tmp.push({ id: this.imgComponent[i].img.id, order: this.imgComponent[i].img.order });
                } else {
                    tmp.push(this.imgComponent[i].img);
                }
            }
            for (let i in tmp) {
                if (tmp[i].id === imgId) {
                    delete tmp[i];
                }
            }
            let imgArray = [];
            for (let i in tmp) {
                tmp[i].order = tmp[i].order - 1;
                imgArray.push(tmp[i]);
            }
            this.$swal({
                title: "Delete this picture?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: "Yes, Delete it!",
                closeOnConfirm: true
            }).then(result => {
                if (result === true) {
                    this.loading = true;
                    httpService.delete("/components/files/" + imgId).then(response => {
                        this.loading = false;
                        let obj = {
                            files: imgArray
                        };
                        this.loading = true;
                        httpService.put("/components/" + this.getDetails(this.$route.params.id).id, JSON.stringify(obj)).then(response => {
                            this.loading = false;
                            location.reload();
                        });
                    });
                }
            });
            this.loading = false;
        },
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        },
        fileType(index) {
            this.type = this.selectedType[index];
            this.erreur = false;
            // Le type peut etre choisi avant l'upload : on attend alors l'image pour creer
            // l'entree, sinon on enverrait un fichier sans filename (erreur 400 cote back).
            if (this.uri === undefined) {
                return;
            }
            this.setPendingImage();
        },
        setPendingImage() {
            const imageFile = {
                filename: this.uri,
                fileType: {
                    id: this.type
                },
                order: this.imgComponent.length + 1,
                id: null
            };
            const pendingIndex = this.imgComponent.findIndex(item => item.id === null);
            if (pendingIndex === -1) {
                this.imgComponent.push({ id: null, img: imageFile });
            } else {
                // On remplace l'image en attente plutot que d'en empiler une nouvelle
                this.imgComponent.splice(pendingIndex, 1, { id: null, img: imageFile });
            }
            this.setImgObject(this.imgComponent);
        },
        onFile(file) {},
        onLoad(dataUri) {
            if (!ALLOWED_IMAGE_DATA_URI.test(dataUri)) {
                this.uploadError = this.$t("imgEditor.invalidFormat");
                this.formatRejected = true;
                this.uri = undefined;
                this.imgType = null;
                return;
            }
            this.uploadError = null;
            this.formatRejected = false;
            let split = dataUri.split("/")[1];
            this.imgType = split.split(";")[0];
            this.uri = dataUri;
            if (this.type !== null) {
                this.setPendingImage();
            }
        },
        onSizeExceeded(size) {
            alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`);
        },
        handleSaveResponse(response) {
            this.loading = false;
            // Le back renvoie ses erreurs sous la forme [{ message, code }]
            const error = Array.isArray(response) ? response[0] : null;
            if (error && parseInt(error.code, 10) >= 400) {
                this.uploadError = error.message || this.$t("imgEditor.invalidFormat");
                return;
            }
            location.reload();
        },
        getItemInfo(id) {
            httpService.get("/components/" + id).then(function(response) {});
        },
        editPhoto() {
            if (this.formatRejected) {
                // Format refuse : le message est deja affiche, inutile d'envoyer la requete
                return;
            }
            if (this.uri === undefined && this.type !== null) {
                this.uploadError = this.$t("imgEditor.noImage");
                return;
            }
            let imgObjectSave = [];
            for (let i in this.imgComponent) {
                this.imgComponent[i].img.order = parseInt(i, 10) + 1;
                this.imgComponent[i].img.id = this.imgComponent[i].id;
                if (this.imgComponent[i].img.hasOwnProperty("medium")) {
                    imgObjectSave.push({ id: this.imgComponent[i].img.id, order: this.imgComponent[i].img.order });
                } else {
                    imgObjectSave.push(this.imgComponent[i].img);
                }
            }
            if (this.product.type.name === "product" && this.uri !== undefined) {
                let imageFile = {
                    filename: this.uri,
                    fileType: {
                        id: 1
                    },
                    order: imgObjectSave.length + 1
                };
                imgObjectSave.push(imageFile);
            }
            let obj = {
                files: imgObjectSave
            };
            if (this.product.type.name === "product" && this.type === null && this.uri !== undefined) {
                this.loading = true;
                httpService
                    .put("/components/" + this.getDetails(this.$route.params.id).id, JSON.stringify(obj))
                    .then(response => this.handleSaveResponse(response));
            } else if (this.uri !== undefined && this.type === null && this.product.type.name !== "product") {
                this.erreur = true;
            } else if (this.uri === undefined && this.type === null) {
                this.loading = true;
                httpService
                    .put("/components/" + this.getDetails(this.$route.params.id).id, JSON.stringify(obj))
                    .then(response => this.handleSaveResponse(response));
            } else if (this.uri !== undefined && this.type !== null) {
                this.loading = true;
                httpService
                    .put("/components/" + this.getDetails(this.$route.params.id).id, JSON.stringify(obj))
                    .then(response => this.handleSaveResponse(response));
            }
        }
    },
    mounted() {
        let fileTypes = cacheService.getRem3rchUser().user.fileTypes;
        let temp = this._.filter(fileTypes, function(o) {
            // removed wireframed iso view : (o.id === 2) and wireframed front view : (o.id === 4)
            // return o.id === 1 || o.id === 2 || o.id === 3 || o.id === 4 || o.id === 5 || o.id === 6;
            return o.id === 1 || o.id === 3 || o.id === 5 || o.id === 6;
        });
        this.userFT = temp;
        this.$store.dispatch("items/getDetails", { id: this.$route.params.id }).then(() => {
            this.product = this.getDetails(this.$route.params.id);
            for (let i in this.product.figures_advanced) {
                this.imgComponent.push({ id: i, img: this.product.figures_advanced[i] });
            }
            this.imgComponent.sort(function(a, b) {
                return a.img.order - b.img.order;
            });
            this.setImgObject(this.imgComponent);
        });
    },
    computed: {
        ...mapGetters({
            getDetails: "items/getDetails",
            getImgObject: "items/getImgObject"
        }),
        retSvg() {
            return this.$store.state.plano.status.builder.svg;
        },
        retMode() {
            return this.$store.state.plano.status.builder.mode;
        },
        retRelatedProduct() {
            return this.$store.state.plano.data.relatedProducts;
        },
        retGroups() {
            return this.$store.state.plano.status.builder.groups;
        },
        retModuleConf() {
            return this.$store.state.plano.status.builder.moduleConf;
        }
    }
};
</script>



// WEBPACK FOOTER //
// ImgEditor.vue?b7aa6128